import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { SymbolPoolAction } from './symbolPool.action';
import { symbolPoolInitialState } from './symbolPool.constant';

export const symbolPoolReducer = reducerWithInitialState(symbolPoolInitialState)
  .case(SymbolPoolAction.select, (state, payload) => {
    const { nodeId } = payload;
    return {
      ...state,
      selected: nodeId,
    };
  })
  .case(SymbolPoolAction.toggleSelect, (state, payload) => {
    const { nodeId } = payload;
    if (state.selected === nodeId) {
      return {
        ...state,
        selected: undefined,
      };
    }
    return {
      ...state,
      selected: nodeId,
    };
  })
  .case(SymbolPoolAction.clearSelect, (state) => {
    return {
      ...state,
      selected: undefined,
    };
  });
